/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AuthService from '@/services/auth';
import Store from '@/store/store';

export default {

  // Hit the login route and get the waybill details
  login(params: { email: string; waybillNumber: string }) {
    return Api().post('/auth/login', params);
  },

  // Hit the check route
  async checkAuth() {
    try {
      const response = await Api().get('/auth/me');

      if (response && response.data) {
        if (response.data.result && response.data.result === 'false') {
          Store.dispatch('auth/setLoggedInState', {
            loggedIn: false,
          });
          Store.dispatch('auth/setToken', {
            token: '',
          });
        } else {
          Store.dispatch('auth/setLoggedInState', {
            loggedIn: true,
          });          
        }
        return '';
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }

    } catch (error) {
      Store.dispatch('auth/setLoggedInState', {
        loggedIn: false,
      });
      Store.dispatch('auth/setToken', {
        token: '',
      });
      if (error.response) {
        return error.response.statusText;
      } else {
        await AuthService.logSupportDebug('auth.ts - checkAuth - 46 - ' + error);
        return Store.getters['app/messages'].couldNotConnect;
      }
    }
  },

  // Hit the log_support_debug route and log a support error in the db
  async logSupportDebug(message: string) {
    try {
      await Api().post('/auth/log_support_debug', { error: message});
    } catch (error) {
      console.log(`${new Date().toISOString().split('.')[0].replace('T', ' ')} - Log Support Debug ERROR: ` + error);
      console.log(`${new Date().toISOString().split('.')[0].replace('T', ' ')} - Log Support Debug MESSAGE: ` + message);
    }
  },
};
